/* @generated */

// src/assets/ui-icon/line/link.tsx
import * as React from "react";
var LinkLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "m16.909 5.35-.258-.258a3.754 3.754 0 0 0-5.303 0L8.591 7.85a3.754 3.754 0 0 0 0 5.303l.258.258a3.734 3.734 0 0 0 4.406.654l.033-.033a.79.79 0 0 0 0-1.06 1.309 1.309 0 0 0-.468-.4 2.25 2.25 0 0 1-2.911-.221l-.258-.258a2.252 2.252 0 0 1 0-3.181l2.758-2.762a2.253 2.253 0 0 1 3.181 0l.258.258a2.246 2.246 0 0 1 .184 2.958c.06.054.122.106.18.163l.258.258c.215.216.41.45.585.7a3.75 3.75 0 0 0-.146-5.137Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M15.15 10.591a3.754 3.754 0 0 0-4.395-.665l-.044.044a.75.75 0 0 0 0 1.06l.258.258c.06.06.132.108.21.142a2.235 2.235 0 0 1 2.911.221l.258.258a2.252 2.252 0 0 1 0 3.182l-2.757 2.76a2.252 2.252 0 0 1-3.182 0l-.258-.259a2.246 2.246 0 0 1-.183-2.957c-.06-.055-.122-.106-.18-.164l-.258-.258a5.25 5.25 0 0 1-.584-.703 3.75 3.75 0 0 0 .145 5.14l.258.258a3.754 3.754 0 0 0 5.303 0l2.757-2.758a3.754 3.754 0 0 0 0-5.302l-.259-.257Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  LinkLine
};
